export function getValueFromMeta(name) {

    const meta = document.querySelector('meta[name="' + name + '"]');

    if (meta) {

        return meta.content;

    }

    return null;

}
